import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';



@Injectable({
  providedIn: 'root'
})

export class GlobalService {
  constructor( private router: Router ) {}
  endpoint = environment.API_URL;
  endpointdocs = environment.DOCS_URL;
  endpointticketsattachments = environment.TICKETSATTACHMENTS_URL;

  public societa:string='MISA';

  public userInitials:string='';
  public fullName:string='';
  
  public USER_KEY = 'auth-user';
  public LOGIN_TOKEN = 'login_token';
  public configModules:any[]=[];
  
  getEndPoint(): string {
    return this.endpoint;
  }


  public getUser(): any {
    const user = localStorage.getItem(this.USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return null;
  }

  
  public getToken() {
    
    return sessionStorage.getItem(this.LOGIN_TOKEN);
  }

  

  // APIs
  public getHeaders() {
    
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:'Bearer ' +  sessionStorage.getItem(this.LOGIN_TOKEN),
    });
  }

 public getHeadersUpload() {  
    return new HttpHeaders({
      Authorization:'Bearer ' +  sessionStorage.getItem(this.LOGIN_TOKEN),
    });
  }
  
  
}
